import { render, staticRenderFns } from "./mutilprivate.vue?vue&type=template&id=07bde32e&scoped=true"
import script from "./mutilprivate.vue?vue&type=script&lang=js"
export * from "./mutilprivate.vue?vue&type=script&lang=js"
import style0 from "./mutilprivate.vue?vue&type=style&index=0&id=07bde32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bde32e",
  null
  
)

export default component.exports